import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../../../Context/App/Provider';
import { getDeploymentDateTime } from '../../../Functions/utils';


export default function PrintDeployments({choice, deployments, selected}) {
  const { t } = useTranslation();
  const [{user}] = useAppContext();


  const getSelectedLocations = () => {
    const locations = selected.locations.map(loc => {
      if (!loc.group) return user.locations.filter(l => l.groupId === loc.value).map(l => l.label.replace(/\u2001/g, '')).join(', ');
      return loc.label.replace(/\u2001/g, '');
    }).join(', ');

    return (
      <tr>
        <td>{t('realtime.print.header.locations' , {s: locations.split(', ').length > 1 ? 's' : ''})}</td>
        <td>{locations}</td>
      </tr>
    );
  };


  useEffect(() => { // Handle print
    const beforePrint = () => document.getElementById('print').style.display = 'block';
    const afterPrint = () => document.getElementById('print').style.display = 'none';

    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);


  return (
    <div id="print">
      <table id="print__header">
        <thead>
          <tr>
            <th id="print__logo">
              <img src="/assets/images/logo.png" alt="Logo"/>
              <p style={{display: 'none' /* used as brand name in excel file */}}>SoftThinks</p>
            </th>
            <th style={{fontSize: '24px', fontWeight: '600'}}>{t('global.dashboard')}</th>
          </tr>
          {/* Spacing */}<tr/><tr/>
        </thead>

        <tbody style={{fontWeight: '600'}}>
          {getSelectedLocations()}

          <tr>
            <td>{t('realtime.print.header.view')}</td>
            <td>{t('realtime.print.header.type.' + choice)}</td>
          </tr>

          {choice === 'active' ? (
            <tr>
              <td>{t('realtime.print.header.active')}</td>
              <td>{String(deployments[choice].length)}</td>
            </tr>
          ) : (<>
            <tr>
              <td>{t('realtime.print.header.successful')}</td>
              <td>{String(deployments[choice].filter(dep => !dep.error_module_end_date).length)}</td>
            </tr>
            <tr>
              <td>{t('realtime.print.header.failed')}</td>
              <td>{String(deployments[choice].filter(dep => dep.error_module_end_date).length)}</td>
            </tr>
          </>)}
          {/* Spacing */}<tr/><tr/><tr/>
        </tbody>
      </table>

      <table id="print__content">
        <thead>
          <tr>
            <th style={{textAlign: 'center'}}>{t('realtime.print.content.date')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left'}}>{t('realtime.print.content.brand')}</th>
            <th style={{textAlign: 'center'}}>{t('realtime.print.content.product')}</th>
            <th style={{textAlign: 'right'}}>{t('realtime.print.content.serial')}</th>
            <th className="separation"/>

            {choice === 'active' && <th style={{textAlign: 'left'}}>{t('realtime.print.content.current_module_name')}</th>}
            {choice === 'active' && <th style={{textAlign: 'right'}}>{t('realtime.print.content.current_module_start_date')}</th>}
            {choice === 'active' && <th className="separation"/>}

            <th style={{textAlign: 'left'}}>{t('realtime.print.content.error_module_end_date')}</th>
            <th style={{textAlign: 'right', minWidth: '75px'}}>{t('realtime.print.content.error_module_result_data')}</th>
          </tr>
        </thead>

        <tbody>
          {deployments[choice].map(dep => {
            let printDeployments;
            const date = getDeploymentDateTime(dep.date);

            if (choice === 'active') {
              printDeployments = (
                <tr style={{margin: '10px 0'}} key={dep.deployment_id}>
                  <td style={{textAlign: 'center'}}>{t('global.months.' + date.month, {day: date.day})}, {date.time}</td>
                  <td className="separation"/>

                  <td style={{textAlign: 'left'}}>{dep.manufacturer}</td>
                  <td style={{textAlign: 'center'}}>{dep.product}</td>
                  <td style={{textAlign: 'right'}}>{dep.serial}</td>
                  <td className="separation"/>

                  <td style={{textAlign: 'left'}}>{dep.current_module_name}</td>
                  <td style={{textAlign: 'right'}}>{dep.current_module_start_date && (() => {
                    const start_date = getDeploymentDateTime(dep.current_module_start_date);
                    return t('global.months.' + start_date.month, {day: start_date.day}) + ', ' + start_date.time
                  })()}</td>
                  <td className="separation"/>

                  <td style={{textAlign: 'left'}}>{dep.error_module_end_date && (() => {
                    const error_date = getDeploymentDateTime(dep.error_module_end_date);
                    return t('global.months.' + error_date.month, {day: error_date.day}) + ', ' + error_date.time
                  })()}</td>
                  <td style={{textAlign: 'right'}}>{dep.error_module_result_data}</td>
                </tr>
              );
            } else {
              printDeployments = (
                <tr style={{margin: '10px 0'}} key={dep.deployment_id}>
                  <td style={{textAlign: 'center'}}>{t('global.months.' + date.month, {day: date.day})}, {date.time}</td>
                  <th className="separation"/>

                  <td style={{textAlign: 'left'}}>{dep.manufacturer}</td>
                  <td style={{textAlign: 'center'}}>{dep.product}</td>
                  <td style={{textAlign: 'right'}}>{dep.serial}</td>
                  <th className="separation"/>

                  <td style={{textAlign: 'left'}}>{dep.error_module_end_date && (() => {
                    const error_date = getDeploymentDateTime(dep.error_module_end_date);
                    return t('global.months.' + error_date.month, {day: error_date.day}) + ', ' + error_date.time
                  })()}</td>
                  <td style={{textAlign: 'right'}}>{dep.error_module_result_data}</td>
                </tr>
              );
            }

            return printDeployments;
          })}
        </tbody>
      </table>
    </div>
  );
}
